import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMerge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.57143 3L6.28571 3C5.02335 3 4 4.00736 4 5.25L4 7.5M8.57143 21H6.28571C5.02335 21 4 19.9926 4 18.75L4 16.5M15.4286 3L17.7143 3C18.9767 3 20 4.00736 20 5.25V7.5M15.4286 21H17.7143C18.9767 21 20 19.9926 20 18.75V16.5M7.96992 9.75L10.8571 12M10.8571 12L7.96992 14.25M10.8571 12H4M16.0301 9.75L13.1429 12M13.1429 12L16.0301 14.25M13.1429 12H20",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMerge;
